import React from "react"
import PropTypes from "prop-types"

// D3
import { scaleLinear, scaleOrdinal } from "d3-scale"
import { stack, stackOffsetExpand } from "d3-shape"

// Components
import HorizontalStackedBarViz from "./HorizontalStackedBarViz"

// Utils
import { colors } from "../utils"

const HorizontalStackedBar = props => {
  // Props
  const { keys, data, containerWidth } = props
  const svgWidth = containerWidth
  const svgHeight = svgWidth * 0.08
  const margin = {
    top: 0.3 * svgHeight,
    bottom: 0,
    left: 0,
    right: 0
  }

  // Dimensions
  const w = svgWidth - margin.left - margin.right
  const h = svgHeight - margin.top - margin.bottom

  // Y Scale
  const x = scaleLinear().range([w, 0])
  // Color Scale
  const z = scaleOrdinal()
    .domain(keys)
    .range(colors)

  // Data
  const barStack = stack()
    .keys(keys)
    .offset(stackOffsetExpand)
  const series = barStack([data])

  // Viz Props
  const vizProps = {
    w,
    h,
    x,
    z,
    series,
    svgWidth,
    svgHeight,
    margin,
    ...props
  }

  return <HorizontalStackedBarViz {...vizProps} />
}

export default HorizontalStackedBar

HorizontalStackedBar.propTypes = {
  containerWidth: PropTypes.number,
  keys: PropTypes.arrayOf(PropTypes.string),
  labels: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.shape({})
}

HorizontalStackedBar.defaultProps = {
  containerWidth: 300,
  keys: ["level_5", "level_4", "level_3", "level_2", "level_1"],
  labels: [""],
  data: {
    level_1: 0,
    level_2: 0,
    level_3: 0,
    level_4: 0,
    level_5: 0
  }
}
